import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class TypeOfIndebtednessInsertService {
	private apiUrl = globalConst.baseAPI;
	constructor(private http: Http) { }

	insertIndebtedness(token, indebtedness: any) {
		

		
		
		
		
		
		
		

		return this.http
			.post(this.apiUrl + "typeofdebt/v1/inserttypeofdebt", indebtedness, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/type-of-indebtedness/service/type-of-indebtedness-insert/type-of-indebtedness-insert.service.ts